'use strict';

module.exports = place;

/* Get the position of `node` in `parent`. */
function place(parent, child) {
  return parent && parent.children && parent.children.indexOf(child);
}



//////////////////
// WEBPACK FOOTER
// ./~/hast-util-to-html/lib/omission/util/place.js
// module id = 182
// module chunks = 96961042003272 139266963665775